export const ACTIVITY_NAME = '千元礼包限时送';